import { useState, useEffect } from "react";

const ProgressiveImage = ({ src, placeholder, children }) => {
  const [currentSrc, setCurrentSrc] = useState(placeholder);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const imageToLoad = new Image();
    imageToLoad.src = src;
    imageToLoad.onload = () => {
      setCurrentSrc(src);
      setLoading(false);
    };
  }, [src]);

  return children(currentSrc, loading);
};

export default ProgressiveImage;
